/* src/app/social-auth-options/social-auth-options.component.scss */
.social-auth-options ion-button {
  --background: white;
  --background-hover: white;
  --background-activated: white;
  --border-radius: 100px;
  margin: 0;
}
.social-auth-options ion-button::part(native) {
  border: 1px solid #cbcbcb;
  padding: 14px;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.0509803922);
}
.social-auth-options ion-icon {
  font-size: 24px;
}
/*# sourceMappingURL=social-auth-options.component-MBNSCCPW.css.map */
